var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "rotate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494249",
    d: "m20.033,12.256c-.418-.054-.786.24-.837.652-.449,3.616-3.543,6.342-7.196,6.342-3.998,0-7.25-3.252-7.25-7.25s3.252-7.25,7.25-7.25c1.634,0,3.198.558,4.456,1.55h-1.456c-.414,0-.75.336-.75.75s.336.75.75.75h3c.414,0,.75-.336.75-.75v-3.05c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.012c-1.497-1.132-3.335-1.762-5.25-1.762C7.175,3.25,3.25,7.175,3.25,12s3.925,8.75,8.75,8.75c4.409,0,8.143-3.292,8.685-7.658.051-.411-.24-.786-.651-.836Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.9687f83e62c95aa6ef6db2cb30d873e7.svg";
export { ForwardRef as ReactComponent };